import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	useTheme,
} from "@mui/material";
import moment from "moment";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { TAccountReport } from "./type/reportType";
type IProps = {
	isLoading: Boolean;
	data: TAccountReport[];
};
const AccountReportTable = ({ isLoading, data }: IProps) => {
	const theme = useTheme();
	return (
		<>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>SL.</TableCell>
							<TableCell>Voucher No.</TableCell>
							<TableCell>Date</TableCell>
							<TableCell>Account Name</TableCell>
							<TableCell>Particular</TableCell>
							<TableCell> Details</TableCell>
							<TableCell>Tr. Type</TableCell>
							<TableCell>Debit</TableCell>
							<TableCell>Credit</TableCell>
							<TableCell>Balance</TableCell>
						</TableRow>
					</TableHead>

					{isLoading ? (
						<TableLoader />
					) : data.length ? (
						<TableBody>
							{data?.map((allAdmin, index) => {
								return (
									<TableRow hover key={allAdmin.ac_id}>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{index + 1}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{allAdmin.voucher_no}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{moment(
													allAdmin.ledger_date
												).format("DD-MMM-YYYY")}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{allAdmin.account_name}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												// gutterBottom
												// noWrap
											>
												{allAdmin.particular}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												// gutterBottom
												// noWrap
											>
												{allAdmin.details}
											</Typography>
										</TableCell>

										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{allAdmin.tr_type}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{allAdmin.type === "OUT" &&
													allAdmin.amount}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{allAdmin.type === "IN" &&
													allAdmin.amount}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{allAdmin.last_balance}
											</Typography>
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					) : (
						<TableNotFound />
					)}
				</Table>
			</TableContainer>
		</>
	);
};

export default AccountReportTable;
